import { resourceNameCompletedCalendarEventId } from 'motw_core/Entity/ICompletedCalendarEventId';
import { ICalendarState } from "../../ICalendarState";
import { GetCompletedCalendarEventIds } from 'source/app/presentation/MainPanel/Calendar/CalendarEvents/Helpers/GetCalendarEventIds';
import MotwLogicServer from 'source/app/services/External/LogicServer/MotwLogicServer';
import { ESharedComponent } from 'source/app/services/UI/State/ESharedComponent';
import { State } from 'source/app/services/UI/State/State';
import ClientDataProvider from 'source/app/services/External/ClientDataProvider/ClientDataProvider';

export async function RemoveInvisibleEventIdsAsync(currentEventIds: string[]) {
	const shouldCleanupOldRecords = currentEventIds.length > 20;

	if (shouldCleanupOldRecords) {
		const invisibleEventIds = GetInvisibleEventIds();

		const deletionQueryString = invisibleEventIds
			.map((id) => 'eventid.eq.' + id)
			.join();

		await ClientDataProvider.DeleteRecordsAsync(
			`${resourceNameCompletedCalendarEventId}?or=(${deletionQueryString})`
		);
	}
}

function GetInvisibleEventIds() {
	const completedEventIds = GetCompletedCalendarEventIds();
	const visibleEventIds = GetVisibleEventIds();

	const invisibleEventIds = completedEventIds.filter(
		(id) => !visibleEventIds.includes(id)
	);

	return invisibleEventIds;
}

function GetVisibleEventIds() {
	const calendar = State.ReadClass<ICalendarState>(ESharedComponent.Calendar);

	if (calendar) {
		const visibleEventIds = calendar.state.eventData.map(
			(event) => event.id
		);

		return visibleEventIds;
	}

	return [];
}
